import React, { useEffect, useState } from 'react';
import InterviewPracticeModeModal from './modeModal';
import InterviewPracticeGateBanner from './banner';
import InterviewPracticeGateCompany from './company';
import InterviewPracticeGateManual from './manual';
import Content from '@common/content';
import { useRouter } from 'next/router';
import { ContentRouteUtil, ContentRouteUrl } from '@utils/routeUtil';
import NoAffiliateAuthModal from '@components/common/modals/affiliateModal/noAffiliateAuthModal';
import LoginModal from '@components/loginModal';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useCheckInProgress } from '@repository/interviewPractices/useInterviewPractices';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';

const noAffiliateAuthModalTitle = (
  <>
    기출 면접 연습 서비스는
    <br />
    인증된 회원만 이용 가능해요.
  </>
);

const InterviewPracticeGate = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { isEventUser, isAuthorityUser } = useCheckAuthority(userData);
  const { data: progressInfo } = useCheckInProgress(isLogin);

  const [noAffiliateAuthModalVisible, setNoAffiliateAuthModalVisible] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState<string>(ContentRouteUrl.PASS_INTERVIEW);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [modeModalVisible, setModeModalVisible] = useState(false);

  const { query } = useRouter();

  //제휴 인증 했는지 여부 체크
  const onCheckAffiliateAuth = () => {
    if (!(isEventUser || isAuthorityUser)) {
      setNoAffiliateAuthModalVisible(true);
      return true;
    }

    return false;
  };

  //면접 연습하러 가기 클릭 이벤트
  const onClickPracticeBtn = async () => {
    if (!isLogin) {
      setRedirectUrl(`${ContentRouteUrl.PASS_INTERVIEW}?open=mode`);
      setLoginModalVisible(true);
      return;
    }

    if (onCheckAffiliateAuth()) return;

    if (progressInfo?.inProgress) {
      setModeModalVisible(true);
    } else {
      ContentRouteUtil.goInterviewStart();
    }
  };

  //면접 기록 확인하러가기 클릭 이벤트
  const onClickHistoryClick = () => {
    if (!isLogin) {
      setRedirectUrl(`${ContentRouteUrl.PASS_INTERVIEW}?open=history`);
      setLoginModalVisible(true);
      return;
    }

    if (onCheckAffiliateAuth()) return;

    ContentRouteUtil.goInterviewHistory();
  };

  useEffect(() => {
    if (query.open && isLogin) {
      setLoginModalVisible(false);

      switch (query.open) {
        case 'mode':
          onClickPracticeBtn();
          break;
        case 'history':
          onClickHistoryClick();
          break;
      }

      ContentRouteUtil.goInterview(true);
    }
  }, [query.open, isLogin]);

  return (
    <Content>
      <div>
        <InterviewPracticeGateBanner onPracticeClick={onClickPracticeBtn} onHistoryClick={onClickHistoryClick} />
        <InterviewPracticeGateCompany />
        <InterviewPracticeGateManual />
      </div>
      <InterviewPracticeModeModal
        visible={modeModalVisible}
        onClose={() => setModeModalVisible(false)}
        progressInfo={progressInfo}
      />
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
      <NoAffiliateAuthModal
        title={noAffiliateAuthModalTitle}
        visible={noAffiliateAuthModalVisible}
        onClose={() => setNoAffiliateAuthModalVisible(false)}
      />
    </Content>
  );
};

export default InterviewPracticeGate;
